import { bff } from '@/lib/http/bff';

export type WorkflowRunStatus = 'PENDING' | 'RUNNING' | 'FAILED' | 'SUCCEEDED' | string;

export type WorkflowRunSummary = {
  ID?: string;
  id?: string;

  WorkflowKey?: string;
  workflow_key?: string;

  Status?: WorkflowRunStatus;
  status?: WorkflowRunStatus;

  CreatedAt?: string;
  created_at?: string;

  UpdatedAt?: string;
  updated_at?: string;

  DurationRunTotalMs?: number | null;
  duration_run_total_ms?: number | null;
};

export type WorkflowRunDetail = {
  ID?: string;
  id?: string;

  WorkflowID?: string;
  workflow_id?: string;

  Status?: WorkflowRunStatus;
  status?: WorkflowRunStatus;

  Metadata?: Record<string, any>;
  metadata?: Record<string, any>;

  Inputs?: Record<string, any>;
  inputs?: Record<string, any>;

  CreatedAt?: string;
  created_at?: string;

  UpdatedAt?: string;
  updated_at?: string;
};

export interface ListWorkflowRunsParams {
  workflow_key?: string;
  status?: WorkflowRunStatus;
  cursor?: number;
  limit?: number;
  from?: string;
  to?: string;
}

export type ListWorkflowRunsResponse = {
  items: WorkflowRunSummary[];
  next_cursor?: number | null;
};

export const listWorkflowRunsApi = (params: ListWorkflowRunsParams = {}): Promise<ListWorkflowRunsResponse> =>
  bff.get<ListWorkflowRunsResponse>('/orchestrator/runs', {
    workflow_key: params.workflow_key,
    status: params.status,
    cursor: params.cursor,
    limit: params.limit,
    from: params.from,
    to: params.to,
  });

export type GetWorkflowRunResponse = {
  run: WorkflowRunDetail;
  summary?: any;
};

export const getWorkflowRunApi = (runId: string): Promise<GetWorkflowRunResponse> =>
  bff.get<GetWorkflowRunResponse>(`/orchestrator/runs/${encodeURIComponent(runId)}`);

export type WorkflowRunStep = {
  step_id?: string;
  StepID?: string;
  id?: string;
  ID?: string;

  status?: WorkflowRunStatus;
  Status?: WorkflowRunStatus;

  attempts?: number;
  Attempts?: number;

  updated_at?: string;
  UpdatedAt?: string;

  last_error?: string;
  LastError?: string;
  error_message?: string;
  ErrorMessage?: string;
};

export type GetWorkflowRunStepsResponse = {
  items?: WorkflowRunStep[];
} | WorkflowRunStep[];

export const getWorkflowRunStepsApi = (runId: string): Promise<GetWorkflowRunStepsResponse> =>
  bff.get<GetWorkflowRunStepsResponse>(`/orchestrator/runs/${encodeURIComponent(runId)}/steps`);
